import { createSlice } from '@reduxjs/toolkit';

const formsSlice = createSlice({
  name: 'forms',
  initialState: {},
  reducers: {
    setForm(state, action) {
      const { name, state: formState } = action.payload;
      const updatedState = { ...state, [name]: formState };

      return updatedState;
    },
    removeForm(state, action) {
      const updatedState = { ...state };

      delete updatedState[action.payload];

      return updatedState;
    },
  },
});

export const formsActions = formsSlice.actions;
export default formsSlice.reducer;
